import * as React from "react";
const SvgMinimize24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 24,
        fill: "black",
        viewBox: "0 0 25 24"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10.5 3v7h-7V8h5V3h2Zm4 0h2v5h5v2h-7V3Zm-11 11h7v7h-2v-5h-5v-2Zm11 0h7v2h-5v5h-2v-7Z",
      clipRule: "evenodd"
    })
  );
export default SvgMinimize24Px;
